import { useFlags } from 'launchdarkly-react-client-sdk';

export enum FeatureFlag {
  EnableTransfersInCash = 'enableTransfersInCash',
  BackdateValuationsAnytime = 'backdateValuationsAnytime',
}

/**
 * Return value of launch darkly boolean flag. Because we are using react, flags passed in
 * should be in camel case rather than dashes e.g. use-this-feature should be useThisFeature
 * @param flag camel case flag to check
 * @returns LD flag value
 */
const useFeature = (flag: string) => {
  const flags = useFlags();
  const flagValue = flags[flag] ?? false;
  return flagValue;
};

export default useFeature;
